import React from 'react';
//import BroadbandCard from './BroadbandCard';
import { useNavigate } from "react-router-dom";
//import { BroadbandCardData } from '../../data/CardData';

const BroadbandCardList = () => {
    const navigate=useNavigate()
    const redirectDashboardPage=()=>{
        navigate('/dashboard')
    }
    const redirectDashboard=()=>{
        navigate("/broadbandDashboard")
    }
    const redirectContact=()=>{
        navigate("/broadbandContactManage")
    }
    const redirectLead=()=>{
        navigate("/broadbandLead")
    }
    const redirectOppotunity = ()=>{
        navigate("/opportunity")
    }
    const redirectCAF=()=>{
        navigate("/broadbandCAF")
    }
    const redirectBuilding=()=>{
        navigate("/broadbandBuilding")
    }
    return (
        <>  
        <div className="container-fluid text-light Header-style header">
            <div className="p-3">
                <span className='' style={{cursor:'pointer'}} onClick={redirectDashboardPage}>
                    <i className="fa-solid fa-arrow-left-long"></i>
                </span>
                <span className='p-1 m-3'>Menu</span>
            </div>
        </div>
            <div className="container-fluid Broadband-main">
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {/* {BroadbandCardData.map((data, id) => (
                        <div className="col" key={id} onClick={() => redirectBroadbandPage(data.path)}>
                            <BroadbandCard title={data.title} />
                        </div>
                    ))} */}
                    <div className="col" >
                        <div className="card mb-3 mt-2 shadow-sm" onClick={redirectDashboard}>
                            <div className="m-2 " style={{display:"inline-flex"}}>
                                <p className="card-text overflow-hidden">My Dashboard</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card mb-3 mt-2 shadow-sm" onClick={redirectContact}>
                            <div className="m-2 " style={{display:"inline-flex"}}>
                                <p className="card-text overflow-hidden">Contact Management</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card mb-3 mt-2 shadow-sm"  onClick={redirectLead}>
                            <div className="m-2 " style={{display:"inline-flex"}}>
                                <p className="card-text overflow-hidden">Lead</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card mb-3 mt-2 shadow-sm"  onClick={redirectOppotunity}>
                            <div className="m-2 " style={{display:"inline-flex"}}>
                                <p className="card-text overflow-hidden">Opportunity</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card mb-3 mt-2 shadow-sm"  onClick={redirectCAF}>
                            <div className="m-2 " style={{display:"inline-flex"}}>
                                <p className="card-text overflow-hidden">CAF</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card mb-3 mt-2 shadow-sm"  onClick={redirectBuilding}>
                            <div className="m-2 " style={{display:"inline-flex"}}>
                                <p className="card-text overflow-hidden">Building/Society vs Plan Availability</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BroadbandCardList;
